import React from "react"

import { VIEW, EDIT } from "const"
import { mtGroupsRoute } from "client/parts/routes"
import { Switch, Route } from "client/components"

import List from "./list"
import View from "./view"
import Edit from "./edit"

const MtGroup = () => (
    <Switch>
        <Route
            exact
            path={mtGroupsRoute}
            component={List}
        />
        <Route
            path={`${mtGroupsRoute}/${VIEW}/:groupId`}
            component={View}
        />
        <Route
            path={`${mtGroupsRoute}/${EDIT}/:groupId`}
            component={Edit}
        />
    </Switch>
)
export default MtGroup
